import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
} from 'react-share';
import { HStack, Image, Text, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import useLanguage from '../../../hooks/useLanguage';

function SocialShareLink() {
    const isEnglish = useLanguage();
    const [currentUrl, setCurrentUrl] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setCurrentUrl(window.location.href);
        }
    }, []);

    return (
        <VStack alignItems="flex-start" gap="0px">
            <Text
                fontSize="14px"
                fontWeight="600"
                color="gunPowder.600"
                pt="8px"
                pb="12px"
            >
                {isEnglish ? 'Share this article' : 'Поделите овај чланак'}
            </Text>
            <HStack>
                <FacebookShareButton
                    url={currentUrl}
                    aria-label="Facebook Share Button"
                >
                    <VStack
                        h="40px"
                        w="40px"
                        justifyContent="center"
                        bg="rawSienna.500"
                        borderRadius="full"
                        _hover={{
                            bg: "rawSienna.600",
                        }}
                    >
                        <Image src="../../../../Icon/facebook.svg" />
                    </VStack>
                </FacebookShareButton>
                <TwitterShareButton url={currentUrl} aria-label="Twitter Share Button">
                    <VStack
                        h="40px"
                        w="40px"
                        justifyContent="center"
                        bg="rawSienna.500"
                        borderRadius="full"
                        _hover={{
                            bg: "rawSienna.600"
                        }}
                    >
                        <Image src="../../../../Icon/twitter.svg" />
                    </VStack>
                </TwitterShareButton>

                <LinkedinShareButton
                    url={currentUrl}
                    aria-label="Linkedin Share Button"
                >
                    <VStack
                        h="40px"
                        w="40px"
                        justifyContent="center"
                        bg="rawSienna.500"
                        borderRadius="full"
                        _hover={{
                            bg: "rawSienna.600"
                        }}
                    >
                        <Image src="../../../../Icon/linkedin.svg" />
                    </VStack>
                </LinkedinShareButton>
            </HStack>
        </VStack>
    );
}

export default SocialShareLink;
